import {QueryValue} from '.';
import {Operator, OperatorMapping, RangeOperatorMapping} from '../../../Searches/consts/operators';
import {TimeUSto5} from '../../../../_shared/GWTBridge/invoke/common';
import {ColumnType} from 'priority-web-sdk/enums';

export type filterType = {value: any; operator: Operator; columnType?: ColumnType};
export const timeUS_5 = 'hh:mm a';

export function serialize(queryValue: QueryValue): filterType {
    const {fromval = '', toval = '', op} = queryValue;
    if (!fromval && !toval) {
        return {
            value: {
                min: '',
                max: ''
            },
            operator: op === '<>' ? Operator.NotEmpty : Operator.Empty
        };
    }
    return {
        value: {
            min: fromval,
            max: toval
        },
        operator: op ? RangeOperatorMapping[op] : Operator.Between
    };
}

export function deserialize(
    {operator, value, columnType}: filterType,
    format?
): Partial<QueryValue> {
    if (
        operator === Operator.Empty ||
        operator === Operator.NotEmpty ||
        (!value?.min && !value?.max)
    ) {
        return {
            fromval: '',
            toval: '',
            op: OperatorMapping[operator]
        };
    }
    let op;
    const needTranslation = format && format === timeUS_5;
    let min = value.min;
    let max = value.max;
    if (operator === Operator.Between) {
        if (!value || (value.min === '' && value.max === '')) {
            op = OperatorMapping[Operator.Between];
            //if ColumnType is Text and one one of the values is missing the op should be '=';
        } else if ((value.min !== '' && value.max !== '') || columnType === ColumnType.Text) {
            op = '=';
            if (columnType === ColumnType.Text && !value.min && value.max) {
                min = value.max;
                max = '';
            }
        } else if (value.max !== '') {
            op = '<=';
        } else if (value.min !== '') {
            op = '>=';
        }
    } else {
        op = OperatorMapping[operator];
    }

    return {
        fromval: value ? (needTranslation ? TimeUSto5(min) : min) : '',
        toval: value ? (needTranslation ? TimeUSto5(max) : max) : '',
        op: op
    };
}
